import { mountApp } from "@runtime-entry";

mountApp();
